// extracted by mini-css-extract-plugin
export default {"starship":"Starship_starship__b-XYK","table":"Starship_table__R9ltP","feature":"Starship_feature__LrBEV"};